import { render, staticRenderFns } from "./auditBasics.vue?vue&type=template&id=672d95f9&scoped=true"
import script from "./auditBasics.vue?vue&type=script&lang=js"
export * from "./auditBasics.vue?vue&type=script&lang=js"
import style0 from "./auditBasics.vue?vue&type=style&index=0&id=672d95f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d95f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672d95f9')) {
      api.createRecord('672d95f9', component.options)
    } else {
      api.reload('672d95f9', component.options)
    }
    module.hot.accept("./auditBasics.vue?vue&type=template&id=672d95f9&scoped=true", function () {
      api.rerender('672d95f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/auditBasics.vue"
export default component.exports